import { redirect } from '@tanstack/react-router'

import { useWhiteLabelStore } from '@/stores/white-label'

/**
 * Blocks access to registration page in white label mode
 * Redirects to /login if white label is active, except when the visitor
 * carries an inviteId — invite emails land on /register?inviteId=xyz and
 * must be able to complete the registration on custom domains
 */
export const blockWhiteLabelRegistration = (inviteId?: string) => {
  const { isWhiteLabel } = useWhiteLabelStore.getState()

  if (isWhiteLabel && !inviteId) {
    throw redirect({
      to: '/login',
    })
  }
}
